export const sequence = {
    sequence_empty_list: 'Un nuevo cuestionario estará disponible próximamente. ¡Te informaremos por SMS o correo electrónico!',
};
